import axios from "axios";
import { useSurveyStore } from "../store/useSurveyStore";

// Determine API base URL.
// An explicit VITE_API_BASE (e.g. the riq-kp-gateway-docker dev-env, which points
// this app at the dockerized recoveryiq-api container) always wins. Otherwise fall
// back to deciding by hostname for deployed/standalone environments.
let baseURL = import.meta.env.VITE_API_BASE;

if (!baseURL) {
	const hostname = window.location.hostname.toLowerCase();

	if (hostname.includes("researchdev.openrecovery.com")) {
		baseURL = "https://api.recoveryiqdev.openrecovery.com/internal/v1";
	} else if (hostname.includes("research.openrecovery.com")) {
		baseURL = "https://api.recoveryiq.openrecovery.com/internal/v1";
	} else if (hostname.includes("localdev") || hostname.includes("localhost")) {
		baseURL = "https://api.localdev/internal/v1";
	} else {
		// ultimate fallback
		baseURL = "https://api.recoveryiq.openrecovery.com/internal/v1";
	}
}

// Main axios client
const apiClient = axios.create({
	baseURL: baseURL,
	headers: {
		"Content-Type": "application/json",
		Accept: "application/json",
	},
	withCredentials: true, // Important for sending session cookies
});

// Add response interceptor to capture error codes
apiClient.interceptors.response.use(
	(response) => {
		// Check if the response has a status of 'error' and a code
		if (response.data && response.data.status === "error" && response.data.code) {
			// Store the error code in the global store
			useSurveyStore.getState().setErrorCode(response.data.code);
		}
		return response;
	},
	(error) => {
		// Handle error responses
		if (error.response && error.response.data && error.response.data.code) {
			// Store the error code from the error response
			useSurveyStore.getState().setErrorCode(error.response.data.code);
		} else if (error.response && error.response.status) {
			// If no specific code, use the HTTP status code
			useSurveyStore.getState().setErrorCode(`HTTP ${error.response.status}`);
		} else {
			// For network errors or other issues
			useSurveyStore.getState().setErrorCode("Network Error");
		}
		return Promise.reject(error);
	}
);

export default apiClient;
